import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const B = 330;

function plek(rect) {
  const vw = window.innerWidth, vh = window.innerHeight, breed = Math.min(B, vw - 24);
  const left = Math.max(12, Math.min(rect.left, vw - breed - 12));
  const onder = rect.bottom + 12 + 190 < vh;
  return { width: breed, left, ...(onder ? { top: rect.bottom + 12 } : { bottom: Math.max(12, vh - rect.top + 12) }) };
}

/** Uitlegballon + spotlight rond het element van de huidige stap; een uitlegstap (zonder knop) staat als kaart midden op het scherm. */
export default function TourBallon({ rect, stap, nr, totaal, onVorige, onVolgende, onSluit }) {
  const pad = 6;
  const uitleg = !stap.selector;
  const midden = { left: "50%", top: "50%", transform: "translate(-50%, -50%)", width: Math.min(440, window.innerWidth - 24) };
  return (
    <div className="fixed inset-0 z-[70]" data-rondleiding-overlay="" data-testid="rondleiding-overlay">
      <div className={`absolute inset-0 ${uitleg ? "bg-[#110B09]/55" : ""}`} onClick={(e) => e.stopPropagation()} />
      {rect && (
        <div className="absolute rounded-lg pointer-events-none ring-2 ring-[#EF3528] transition-[top,left,width,height] duration-300"
          style={{ top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2, boxShadow: "0 0 0 9999px rgba(17,11,9,0.55)" }}
          data-testid="rondleiding-spotlight" />
      )}
      <div className="absolute rounded-xl bg-white shadow-2xl p-4 space-y-2 animate-in fade-in slide-in-from-bottom-2"
        style={uitleg ? midden : rect ? plek(rect) : { left: 12, bottom: 12, width: Math.min(B, window.innerWidth - 24) }}
        data-testid={uitleg ? "rondleiding-uitleg" : "rondleiding-ballon"}>
        <div className="flex items-center justify-between">
          <span className="text-[11px] font-semibold text-[#EF3528] tabular-nums" data-testid="rondleiding-teller">Stap {nr} van {totaal}{uitleg ? " · uitleg" : ""}</span>
          <button className="text-slate-400 hover:text-slate-700" onClick={onSluit} aria-label="Sluiten" data-testid="rondleiding-sluiten"><X className="w-4 h-4" /></button>
        </div>
        <div className="font-semibold text-[#110B09]" data-testid="rondleiding-stap-titel">{stap.titel}</div>
        <p className="text-sm text-slate-700 whitespace-pre-line" data-testid="rondleiding-stap-tekst">{stap.tekst}</p>
        <div className="flex justify-between pt-1">
          <Button size="sm" variant="ghost" onClick={onVorige} disabled={nr <= 1} data-testid="rondleiding-vorige">Vorige</Button>
          <Button size="sm" onClick={onVolgende} className="bg-[#110B09] hover:bg-black" data-testid="rondleiding-volgende">{nr >= totaal ? "Klaar" : "Volgende"}</Button>
        </div>
      </div>
    </div>
  );
}
